import Contacte from "../../model/inscripcions/Contacte";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcionsContacteSwitch = async ( id: string,  page : string, contacte : Contacte) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions/${id}/autoritzats/switch`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(contacte)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
